'use client'
import { motion, useMotionValue, useTransform, animate } from 'framer-motion'
import { useEffect } from 'react'
import { useSubdomain } from '@/hooks/useSubdomain'

export interface IRedoAnimTextProps {
  delay: number
}

export default function RedoAnimText({ delay }: IRedoAnimTextProps) {
  const subdomain = useSubdomain()

  const textIndex = useMotionValue(0)
  const texts = [
    'I am looking for a used skid steer with less than 1,000 hours',
    ...(subdomain === 'titan' || subdomain === 'kcbobcat'
      ? []
      : ['What attachments will fit on my 1025R?']),
    'I have a _____; what tractor size would you recommend?',
    'Do you have any like new options within 250 miles of ____'
  ]

  const baseText = useTransform(textIndex, latest => texts[latest] || '')
  const count = useMotionValue(0)
  const rounded = useTransform(count, latest => Math.round(latest))
  const displayText = useTransform(rounded, latest =>
    baseText.get().slice(0, latest)
  )
  const updatedThisRound = useMotionValue(true)

  useEffect(() => {
    animate(count, 120, {
      type: 'tween',
      delay: delay,
      duration: 2,
      ease: 'easeIn',
      repeat: Infinity,
      repeatType: 'reverse',
      repeatDelay: 2,
      onUpdate(latest) {
        if (updatedThisRound.get() === true && latest > 0) {
          updatedThisRound.set(false)
        } else if (updatedThisRound.get() === false && latest === 0) {
          if (textIndex.get() === texts.length - 1) {
            textIndex.set(0)
          } else {
            textIndex.set(textIndex.get() + 1)
          }
          updatedThisRound.set(true)
        }
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <motion.span className="inline text-xs lg:text-base">
      {displayText}
    </motion.span>
  )
}
